var map = {
	"./Aprendizaje.svg": "034b",
	"./Pot1.svg": "3e65",
	"./Pot2.svg": "b667",
	"./Pot3.svg": "5e3c",
	"./Recursamiento.svg": "7dd3",
	"./Solicitud.svg": "1398",
	"./api.svg": "a3f5",
	"./ayuda-indetec.svg": "6771",
	"./badge.svg": "6ca7",
	"./demand.svg": "1c90",
	"./email.svg": "9da9",
	"./faq-illustrations.svg": "9d64",
	"./happy-computer.png": "7795",
	"./marketing.svg": "9fb4",
	"./notification-bell.png": "0a23",
	"./personalization.svg": "0e58",
	"./pricing-Illustration.svg": "399a",
	"./sad-computer.png": "b39c",
	"./sales.svg": "677a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "694b";